import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next";
import useApi from "../../../utils/api";
import { getErrorMessage } from "../../../utils/helpers/errors";

export const useRetroApi = () => {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalItems, setTotalItems] = useState(0);

    const { authGet, authPost } = useApi();

    const get = useCallback(async (params, controller) => {
        setLoading(true);
        try {
            const response = await authGet("/retro-adjustment", {
                params,
                signal: controller.signal
            });
            if (response) {
                setData(response.result);
                setTotalItems(response.totalItems);
            }
        } catch (err) {
            getErrorMessage(err, t);
        } finally {
            setLoading(false);
        }
    }, [authGet, t]);


    const updateRetroStatus = useCallback(async (id, type, data, onSuccess) => {
        try {
            const response = await authPost(`/retro-adjustment/${id}/${type}`, { data });
            onSuccess?.(response);
        } catch (err) {
            getErrorMessage(err, t);
        }
    }, [authPost, t]);

    return {
        get,
        updateRetroStatus,
        data,
        loading,
        totalItems,
        setData,
        setTotalItems
    };
}